export default __webpack_public_path__ + "static/media/lessons-icon.549f5a20.svg";